import * as actionTypes from './actionTypes';
import constants from '../../commonUtils/constants';

const initialState = {
    ExtOutputMappings: constants.extraction.listInitialState,
    loading: false,
    loadingSingle: false,
    extOutputMapping: {
        dataGroup: {},
        dataCategory: {},
    },
    extOutputMappingId: undefined,
    errors: null,
    reprocessing: false,
};

const extOutputMappingsReducer = (state = initialState, action) => {
        if (action.type === 'RESET_SINGLE_OUTPUT_MAPPING') {
            return {
                ...state,
                extOutputMapping: initialState.extOutputMapping,
                extOutputMappingId: undefined,
                errors: null,
            };
        }
    switch (action.type) {
        case actionTypes.SET_LOADING:
            return {
                ...state,
                loading: action.payload,
                errors: null,
            };
        case actionTypes.SET_REPROCESSING:
            return {
                ...state,
                reprocessing: action.payload,
                errors: null,
            };
        case actionTypes.GET_OUTPUT_MAPPINGS_SUCCESS:
            return {
                ...state,
                loading: false,
                ExtOutputMappings: action.payload,
                errors: null,
            };
        case actionTypes.GET_OUTPUT_MAPPINGS_FAILURE:
            return {
                ...state,
                loading: false,
                errors: action.payload,
            };
        case actionTypes.REPROCESS_OUTPUT_MAPPINGS_SUCCESS:
            return {
                ...state,
                reprocessing: false,
                errors: null,
            };
        case actionTypes.REPROCESS_OUTPUT_MAPPINGS_FAILURE:
            return {
                ...state,
                reprocessing: false,
                errors: action.payload,
            };
        case actionTypes.GET_SINGLE_OUTPUT_MAPPING_SUCCESS:
            return {
                ...state,
                loading: false,
                extOutputMapping:   action.payload,
                extOutputMappingId: action.payload._id,
                errors: null,
            };
        case actionTypes.GET_SINGLE_OUTPUT_MAPPING_FAILURE:
            return {
                ...state,
                loading: false,
                errors: action.payload,
            };
        default:
            return state;
    }
};

export default extOutputMappingsReducer;
